
import { User } from "oidc-client";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import useAuth from "../../providers/authProvider";


const SigninCallback = ({ ...props }: any) => {
  const { signinRedirectCallback, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    signinRedirectCallback()
      .then((user: User) => {
        if (user.state !== null && user.state !== undefined) {
            navigate('/commission');
        }       
      })
      .catch((err: any) => {
        console.log("Error during processing callback data, cause : " + err);
        logout(); // Logout user to clear data then redirect to base path

      });
  });

  return <p>LOADING</p>;
};

export default SigninCallback;